// extracted by mini-css-extract-plugin
module.exports = {"viewSwitcher":"ob_u71cLl","viewSwitcher_item":"ob_9DCDFK","viewSwitcher_item_selected":"ob_KTT5KR"};